export default {
  titulo: 'Legislação Específica para Aeródromos e Objetos Projetados no Espaço Aéreo',
};
